export default __webpack_public_path__ + "static/media/error@2x.3c97e759.png";